import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";

export const APIError = ({ error }: { error: string }) => {
  const { t } = useTranslation();
  return (
    <div>
      <Alert severity="error">{t(error)}</Alert>
    </div>
  );
};
